import * as React from "react";
import { connect } from "react-redux";

import {
  PointsHistory as PointsHistoryComponent,
  PointsHistoryProps,
} from "../../components/PointsHistory/PointsHistory";

class PointsHistory extends React.Component<PointsHistoryProps> {
  render() {
    return <PointsHistoryComponent {...this.props} />;
  }
}

export default connect(null, {})(PointsHistory);
